
import withModal from 'lib/helpers/hoc/withModal'
import React, { FC, useState } from 'react'
import Step1EmployeeInfo from './add-new-employee-steps/Step1EmployeeInfo';
import Step2ChooseRole from './add-new-employee-steps/Step2ChooseRole';
import Step3ChooseSalary from './add-new-employee-steps/Step3ChooseSalary';
import ConditionalRender from 'components/atoms/conditional-render/ConditionalRender';
import Icon from 'components/atoms/icon/Icon';
import { IconType } from 'lib/helpers/constants/iconTypes';
import Step2CreateRole from './add-new-employee-steps/Step2CreateRole';
import StepsCounter from './steps-counter/StepsCounter';
import Step4AddExpenses from './add-new-employee-steps/Step4AddExpenses';
import Step5AdditionalCompensation from './add-new-employee-steps/Step5AdditionalCompensation';
import Step6AddGoals from './add-new-employee-steps/Step6AddGoals';
import Step7AddBonuses from './add-new-employee-steps/Step7AddBonuses';


export interface IAddNewEmployeeProps {
    onConfirm: () => void;
    currentStep: number;
    setCurrentStep: (step: number) => void;
}
const AddNewEmployee: FC<IAddNewEmployeeProps> = ({ onConfirm, currentStep, setCurrentStep }) => {

    const [AllData, setAllData] = useState({
        permission: [],
        expenses:[
            {type: 'Social Insurance', name: 'AHV/IV/EO', amount: 5.3, measurement_type: '%'},
            {type: 'Social Insurance', name: 'ALV', amount: 1.1, measurement_type: '%'},
            {type: 'Social Insurance', name: 'NBU', amount: 1.734, measurement_type: '%'},
            {type: 'Social Insurance', name: 'NBU-Z', amount: 0.086, measurement_type: '%'},
            {type: 'Social Insurance', name: 'BVG-Abzug in %', amount: 4, measurement_type: '%'}
        ]
    })

    return (
        <>
            <ConditionalRender condition={currentStep !== 1}>
                <button
                    type="button"
                    className="absolute top-[26px] sm:top-[31px] md:top-[45px]"
                    onClick={() => {
                        setCurrentStep(currentStep === 8 ? 2 : currentStep - 1);
                    }}
                >
                    <Icon
                        iconType={IconType.BACK_BUTTON_MODAL}
                        color={'var(--theme)'}
                    />
                </button>
            </ConditionalRender>
            <ConditionalRender condition={currentStep !== 8}>
                <StepsCounter currentStep={currentStep} />
            </ConditionalRender>

            {{
                1: <Step1EmployeeInfo setCurrentStep={setCurrentStep} setAllData={setAllData} AllData={AllData} />,
                2: <Step2ChooseRole setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} />,
                3: <Step3ChooseSalary setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} />,
                4: <Step4AddExpenses setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} />,
                5: <Step5AdditionalCompensation setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} />,
                6: <Step6AddGoals setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} />,
                7: <Step7AddBonuses AllData={AllData} setAllData={setAllData} onConfirm={onConfirm} />,
                8: <Step2CreateRole setCurrentStep={setCurrentStep} AllData={AllData} setAllData={setAllData} onConfirm={onConfirm} />,
            }[currentStep]}
        </>
    )
}

export default withModal(AddNewEmployee)